import { useGetUserSubjectsQuery } from "api/generated";
import { useEffect } from "react";
import { processApiError } from "utils/processApiError";

export const useUserSubjects = () => {
  const { data, error } = useGetUserSubjectsQuery();

  useEffect(() => {
    if (error === undefined) return;

    processApiError(error);
  }, [error]);

  return { userSubjects: data?.userSubjects, error };
};
